<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3"><a id="page_2"></a><a id="page_3"></a><a id="ch1"></a><em>What He Thought</em></h3>
<h3 class="h3a"><em>for Fabbio Doplicher</em></h3>
<p class="noindent">We were supposed to do a job in Italy</p>
<p class="noindent">and, full of our feeling for</p>
<p class="noindent">ourselves (our sense of being</p>
<p class="noindent">Poets from America) we went</p>
<p class="noindent">from Rome to Fano, met</p>
<p class="noindent">the mayor, mulled</p>
<p class="noindent">a couple matters over (what’s</p>
<p class="noindent">cheap date, they asked us; what’s</p>
<p class="noindent">flat drink). Among Italian literati</p>
<p class="noindentt">we could recognize our counterparts:</p>
<p class="noindent">the academic, the apologist,</p>
<p class="noindent">the arrogant, the amorous,</p>
<p class="noindent">the brazen and the glib—and there was one</p>
<p class="noindentt">administrator (the conservative), in suit</p>
<p class="noindent">of regulation gray, who like a good tour guide</p>
<p class="noindent">with measured pace and uninflected tone narrated</p>
<p class="noindent">sights and histories the hired van hauled us past.</p>
<p class="noindent">Of all, he was most politic and least poetic,</p>
<p class="noindent">so it seemed. Our last few days in Rome</p>
<p class="noindent">(when all but three of the New World Bards had flown)</p>
<p class="noindent">I found a book of poems this</p>
<p class="noindent">unprepossessing one had written: it was there</p>
<p class="noindent">in the <em>pensione</em> room (a room he’d recommended)</p>
<p class="noindent">where it must have been abandoned by</p>
<p class="noindent">the German visitor (was there a bus of <em>them</em>?)</p>
<p class="noindent">to whom he had inscribed and dated it a month before.</p>
<p class="noindent">I couldn’t read Italian, either, so I put the book</p>
<p class="noindent">back into the wardrobe’s dark. We last Americans</p>
<p class="noindentt">were due to leave tomorrow. For our parting evening then</p>
<p class="noindent">our host chose something in a family restaurant, and there</p>
<p class="noindent">we sat and chatted, sat and chewed,</p>
<p class="noindent">till, sensible it was our last</p>
<p class="noindent">big chance to be poetic, make</p>
<p class="noindent">our mark, one of us asked</p>
<p class="noindent">                                        “What’s poetry?</p>
<p class="noindent"><a id="page_4"></a>Is it the fruits and vegetables and</p>
<p class="noindent">marketplace of Campo dei Fiori, or</p>
<p class="noindent">the statue there?” Because I was</p>
<p class="noindentt">the glib one, I identified the answer</p>
<p class="noindent">instantly, I didn’t have to think—“The truth</p>
<p class="noindent">is both, it’s both,” I blurted out. But that</p>
<p class="noindent">was easy. That was easiest to say. What followed</p>
<p class="noindent">taught me something about difficulty,</p>
<p class="noindent">for our underestimated host spoke out,</p>
<p class="noindent">all of a sudden, with a rising passion, and he said:</p>
<p class="noindentt">The statue represents Giordano Bruno,</p>
<p class="noindent">brought to be burned in the public square</p>
<p class="noindent">because of his offense against</p>
<p class="noindent">authority, which is to say</p>
<p class="noindent">the Church. His crime was his belief</p>
<p class="noindent">the universe does not revolve around</p>
<p class="noindent">the human being: God is no</p>
<p class="noindent">fixed point or central government, but rather is</p>
<p class="noindent">poured in waves through all things. All things</p>
<p class="noindent">move. “If God is not the soul itself, He is</p>
<p class="noindent">the soul of the soul of the world.” Such was</p>
<p class="noindent">his heresy. The day they brought him</p>
<p class="noindent">forth to die, they feared he might</p>
<p class="noindent">incite the crowd (the man was famous</p>
<p class="noindent">for his eloquence). And so his captors</p>
<p class="noindent">placed upon his face</p>
<p class="noindent">an iron mask, in which</p>
<p class="noindentt">he could not speak. That’s</p>
<p class="noindent">how they burned him. That is how</p>
<p class="noindent">he died: without a word, in front</p>
<p class="noindent">of everyone.</p>
<p class="noindent">               And poetry—</p>
<p class="noindent">                                    (we’d all</p>
<p class="noindent">put down our forks by now, to listen to</p>
<p class="noindent">the man in gray; he went on</p>
<p class="noindent">softly)—</p>
<p class="noindent">                         poetry is what</p>
<p class="noindentt">he thought, but did not say.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter01.vue?a886cd42